import React, { useState, useContext, useRef } from "react";
import { hierarchyEntitiesType, FolderBreadcrumbType } from "../types";
import { PhotoManagerContext } from "../index";
import { usePopupClickOutside } from "../../../../hooks/usePopupClickOutside";
const shortcutIcon = require("../../styles/images/shortcut-icon.svg");
const folderIcon = require("../../styles/images/folder-icon.svg");

interface FolderBreadcrumbProps {
  folderId: number;
  goToLibrary: () => void;
  handleFolderOpen: (folderId: number) => void;
  isLoadingFolder: boolean;
  activeFolder: FolderBreadcrumbType | null;
}

const FolderBreadcrumb: React.FC<FolderBreadcrumbProps> = ({
  folderId,
  goToLibrary,
  handleFolderOpen,
  isLoadingFolder,
  activeFolder
}) => {
  const context = useContext(PhotoManagerContext);
  const popUpRef = useRef<HTMLDivElement>(null);
  const [showHiddenLinks, setShowHiddenLinks] = useState<boolean>(false);

  usePopupClickOutside(popUpRef, () => {
    setShowHiddenLinks(false);
  });

  const isDeeplyNested = activeFolder && activeFolder.hierarchy.length > 2;
  const hiddenLinks = activeFolder && activeFolder.hierarchy.slice(0, -2);
  const shownLinks = activeFolder && activeFolder.hierarchy.slice(-2);

  const renderParentLinks = () => {
    if (isDeeplyNested) {
      return (
        <>
          <div className="deeply-nested-view">
            <button
              type="button"
              className="green-text geo-text-btn"
              onClick={() => setShowHiddenLinks(!showHiddenLinks)}
            >
              ...
            </button>
            {showHiddenLinks && (
              <div className="hidden-links-card">
                {hiddenLinks?.map((link: hierarchyEntitiesType) => {
                  return (
                    <div>
                      <button
                        type="button"
                        className="hidden-links geo-text-btn text-limit black-text"
                        onClick={() => {
                          handleFolderOpen(link.id);
                          setShowHiddenLinks(false);
                        }}
                      >
                        {link.entityType === "LibraryFolderReference" ? (
                          <img src={shortcutIcon} />
                        ) : (
                          <img src={folderIcon} />
                        )}

                        {link.name}
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
          <span className="grey-text bc-links-divider"> / </span>
          {shownLinks?.map((parent: hierarchyEntitiesType) => {
            return (
              <>
                <button
                  type="button"
                  className="green-text geo-text-btn text-limit-w"
                  onClick={() => {
                    handleFolderOpen(parent.id);
                    setShowHiddenLinks(false);
                  }}
                >
                  {parent.name}
                </button>
                <span className="grey-text bc-links-divider"> / </span>
              </>
            );
          })}
        </>
      );
    }
    return (
      <>
        {activeFolder?.hierarchy.map((parent: hierarchyEntitiesType) => {
          return (
            <>
              <button
                type="button"
                className="green-text geo-text-btn text-limit-w"
                aria-label="Back to Library"
                onClick={() => {
                  handleFolderOpen(parent.id);
                  setShowHiddenLinks(false);
                }}
              >
                {parent.name}
              </button>
              <span className="grey-text bc-links-divider"> / </span>
            </>
          );
        })}
      </>
    );
  };

  return (
    <>
      <div
        className="ws-breadcrumbs ws-action-and-breadcrumbs folder-breadcrumbs"
        ref={popUpRef}
      >
        <div className="album-breadcrumb-left-content">
          <p className="ws-head-txt">
            <button
              type="button"
              className="green-text geo-text-btn"
              aria-label="Back to Library"
              onClick={() => goToLibrary()}
            >
              Library
            </button>
            <span className="grey-text bc-links-divider"> / </span>
            {renderParentLinks()}
            {isLoadingFolder ? (
              <span className="loading-spinner">
                <span className="fa fa-spinner fa-spin"></span>
              </span>
            ) : (
              <span
                className="grey-text grey-text-limit-w"
                data-toggle="tooltip"
                data-placement="bottom"
              >
                {activeFolder?.name}
              </span>
            )}
          </p>
        </div>
      </div>
    </>
  );
};

export default FolderBreadcrumb;
